export const isBlank = (value) => !String(value ?? "").trim();

const coerceArrayField = (value, fallback) => {
  if (Array.isArray(value)) return value;
  if (value == null || value === "") return fallback;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed;
    } catch {
      // legacy plain-text role fields
    }
    return value.trim() ? [value.trim()] : fallback;
  }
  return fallback;
};

export const mergeAiSystemForm = (emptyForm, aiSystem) => {
  if (!aiSystem) {
    return { ...emptyForm };
  }
  const merged = { ...emptyForm, ...aiSystem };
  Object.entries(emptyForm).forEach(([key, fallback]) => {
    if (Array.isArray(fallback)) {
      merged[key] = coerceArrayField(merged[key], fallback);
      return;
    }
    if (
      merged[key] == null &&
      (typeof fallback === "string" || Array.isArray(fallback))
    ) {
      merged[key] = fallback;
    }
  });
  return merged;
};
